import { ATTRIBUTES, type Attribute, type OrdinaryAttribute, type SoulChainSelection } from "../types";

const assetUrl = (path: string) => `${import.meta.env.BASE_URL}${path}`;

const ATTRIBUTE_ASSETS: Record<OrdinaryAttribute | "神" | "魔", string> = {
  炎: "fire.png",
  冰: "ice.png",
  雷: "thunder.png",
  光: "light.png",
  暗: "dark.png",
  幽: "ghost.png",
  神: "divine.png",
  魔: "demon.png",
};

interface AttributeSelectorProps {
  label: string;
  side: "attack" | "defense";
  value: Attribute;
  onChange: (attribute: Attribute) => void;
}

export function AttributeSelector({ label, side, value, onChange }: AttributeSelectorProps) {
  return (
    <fieldset className={`attribute-selector ${side}`}>
      <legend>{label}</legend>
      <div className="attribute-grid">
        {ATTRIBUTES.map((attribute) => (
          <button
            type="button"
            key={attribute}
            className={value === attribute ? "selected" : ""}
            aria-pressed={value === attribute}
            onClick={() => onChange(attribute)}
          >
            {attribute === "无" ? (
              <span className="neutral-glyph">无</span>
            ) : (
              <img src={assetUrl(`assets/attributes/${ATTRIBUTE_ASSETS[attribute]}`)} alt="" />
            )}
            <span>{attribute}</span>
          </button>
        ))}
      </div>
    </fieldset>
  );
}

interface SoulChainSelectorProps {
  label: string;
  options: OrdinaryAttribute[];
  value: SoulChainSelection;
  onChange: (value: SoulChainSelection) => void;
}

export function SoulChainSelector({ label, options, value, onChange }: SoulChainSelectorProps) {
  if (options.length === 0) return null;

  return (
    <div className="soul-chain" role="group" aria-label={label}>
      <div className="soul-chain-heading">
        <span>{label}</span>
        <small>命中对应属相时生效20%</small>
      </div>
      <div className="soul-options">
        <button
          type="button"
          className={value === null ? "selected" : ""}
          aria-pressed={value === null}
          onClick={() => onChange(null)}
        >
          不选择
        </button>
        {options.map((attribute) => (
          <button
            type="button"
            key={attribute}
            className={value === attribute ? "selected" : ""}
            aria-pressed={value === attribute}
            onClick={() => onChange(attribute)}
          >
            <img src={assetUrl(`assets/attributes/${ATTRIBUTE_ASSETS[attribute]}`)} alt="" />
            {attribute}
          </button>
        ))}
      </div>
    </div>
  );
}
